/* ===== Submenu: active on view + scroll with offset ===== */
(() => {
    const submenu = document.querySelector('.submenu');
    if (!submenu) return; // ⬅️ najpierw null-check

    // Sticky cień
    const stuckObserver = new IntersectionObserver(
        ([e]) => submenu.classList.toggle('is-stuck', e.intersectionRatio < 1),
        {threshold: [1]}
    );
    stuckObserver.observe(submenu);

    const OFFSET = 144;
    const scroller = submenu.querySelector('.scrollbar') || submenu.querySelector('.submenu__list'); // ⬅️ kontener do przewijania
    const list = submenu.querySelector('.submenu__list');
    const items = Array.from(submenu.querySelectorAll('.submenu__list-item'));
    const links = Array.from(submenu.querySelectorAll('a[href]'));

    const hashLinks = links.filter(a => a.getAttribute('href').startsWith('#'));
    const sections = hashLinks
        .map(a => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))))
        .filter(Boolean);

    let ticking = false;
    let isAutoScrolling = false;
    let autoScrollTimer = null;
    let currentActiveId = null;

    const stopAutoScrolling = () => {
        isAutoScrolling = false;
        if (autoScrollTimer) {
            clearTimeout(autoScrollTimer);
            autoScrollTimer = null;
        }
    };
    window.addEventListener('scrollend', stopAutoScrolling);

    // helper: wyrównaj item do początku scroller-a (z uwzględnieniem scroll-padding)
    const alignItemToStart = (container, item, {smooth = true} = {}) => {
        if (!container || !item) return;

        const cs = getComputedStyle(container);
        const dir = cs.direction || 'ltr';
        const padL = parseFloat(cs.scrollPaddingLeft || cs.scrollPadding || 0) || 0;
        const padR = parseFloat(cs.scrollPaddingRight || cs.scrollPadding || 0) || 0;

        // pozycja itemu względem kontenera
        const itemLeft = item.offsetLeft - container.offsetLeft;
        const behavior = smooth ? 'smooth' : 'auto';

        if (dir === 'rtl') {
            // w RTL scrollLeft bywa ujemny — bezpieczniej liczyć od prawej krawędzi
            const rightEdge = container.scrollWidth - (itemLeft + item.offsetWidth);
            const target = Math.max(0, rightEdge - padR);
            container.scrollTo({left: target, behavior});
        } else {
            const target = Math.max(0, itemLeft - padL);
            container.scrollTo({left: target, behavior});
        }
    };

    const setActive = (id, {fromClick = false} = {}) => {
        if (!id || id === currentActiveId) return;

        currentActiveId = id;

        items.forEach(li => li.classList.remove('active'));
        links.forEach(a => a.removeAttribute('aria-current'));

        const a = hashLinks.find(link => decodeURIComponent(link.getAttribute('href')).replace('#', '') === id);
        if (!a) return;

        a.setAttribute('aria-current', 'true');
        const li = a.closest('.submenu__list-item');
        if (li) {
            li.classList.add('active');

            // ZAWSZE wyrównuj aktywny element do początku scroller-a
            // – zarówno po kliknięciu, jak i przy scroll-spy.
            alignItemToStart(scroller, li, {smooth: true});
        }
    };

    const scrollToSection = (id, {updateHash = true} = {}) => {
        const target = document.getElementById(id);
        if (!target) return;

        const y = window.scrollY + target.getBoundingClientRect().top - OFFSET;

        isAutoScrolling = true;
        window.scrollTo({top: Math.max(0, y), behavior: 'smooth'});

        // fallback gdy 'scrollend' nie zadziała
        autoScrollTimer = setTimeout(stopAutoScrolling, 800);

        if (updateHash) history.pushState(null, '', `#${encodeURIComponent(id)}`);
    };

    // Klik w pozycję
    hashLinks.forEach(a => {
        a.addEventListener('click', (e) => {
            e.preventDefault();
            const id = decodeURIComponent(a.getAttribute('href').slice(1));
            scrollToSection(id, {updateHash: true});
            setActive(id, {fromClick: true});
        });
    });

    const isInViewWithOffset = (section) => {
        const r = section.getBoundingClientRect();
        const y = OFFSET;
        return r.top <= y && r.bottom > y;
    };

    const updateOnScroll = () => {
        if (ticking || isAutoScrolling) return;
        ticking = true;
        requestAnimationFrame(() => {
            ticking = false;
            const current = sections.find(isInViewWithOffset);
            if (current) setActive(current.id);
        });
    };

    window.addEventListener('scroll', updateOnScroll, {passive: true});
    window.addEventListener('resize', updateOnScroll);

    // wstecz/dalej
    window.addEventListener('hashchange', () => {
        const id = decodeURIComponent(location.hash.slice(1));
        if (!id) return;
        scrollToSection(id, {updateHash: false});
        setActive(id);
    });

    // Start
    const init = () => {
        if (location.hash) {
            const id = decodeURIComponent(location.hash.slice(1));
            const target = document.getElementById(id);
            if (target) {
                const y = window.scrollY + target.getBoundingClientRect().top - OFFSET;
                window.scrollTo(0, Math.max(0, y));
                setActive(id, {fromClick: false});
                return;
            }
        }
        updateOnScroll();
    };

    init();
})();

// gallery + lightbox (fix drag-freeze on resize/close + Esc/backdrop close)
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.hero__image').forEach(root => {

        const mainHolder = root.querySelector('.hero__image-main .holder');
        const thumbsWrap = root.querySelector('.hero__image-thumbs');
        const thumbsUl = thumbsWrap?.querySelector('.thumbs');
        const items = Array.from(thumbsUl?.querySelectorAll('.thumbs__item') || []);


        const btnPrev = root.querySelector('.hero__image-main .icon-left');
        const btnNext = root.querySelector('.hero__image-main .icon-right');
        const btnZoom = root.querySelector('.hero__image-main .icon-zoom');

        // disable native img drag
        root.querySelectorAll('img').forEach(i => i.setAttribute('draggable', 'false'));
        root.addEventListener('dragstart', e => e.preventDefault());

        // sources from thumbs (fallback: img in holder)
        const getData = li => {
            const img = li.querySelector('img');
            return {src: img?.getAttribute('src') || '', alt: img?.getAttribute('alt') || ''};
        };
        let sources = items.map(getData);
        const fallbackImg = mainHolder.querySelector('img');
        if (!sources.length && fallbackImg) sources = [{src: fallbackImg.src, alt: fallbackImg.alt || '', large: fallbackImg.dataset.largeImage || ''}];

        // move padding from holder into slides (avoid offset)
        const cs = getComputedStyle(mainHolder);
        const pad = {
            t: +parseFloat(cs.paddingTop) || 0,
            r: +parseFloat(cs.paddingRight) || 0,
            b: +parseFloat(cs.paddingBottom) || 0,
            l: +parseFloat(cs.paddingLeft) || 0,
        };
        mainHolder.style.padding = '0';

        // build track: [cloneLast, ...slides, cloneFirst]
        const track = document.createElement('div');
        track.className = 'track';
        const makeSlide = ({src, alt}) => {
            const s = document.createElement('div');
            s.className = 'slide';
            s.style.padding = `${pad.t}px ${pad.r}px ${pad.b}px ${pad.l}px`;
            const i = document.createElement('img');
            // SLICD-34: zdjęcia nagród mają po ~1 MB i są niżej na stronie - leniwie
            i.loading = 'lazy';
            i.decoding = 'async';
            i.src = src;
            i.alt = alt || '';
            s.appendChild(i);
            return s;
        };
        track.appendChild(makeSlide(sources[sources.length - 1]));
        sources.forEach(d => track.appendChild(makeSlide(d)));
        track.appendChild(makeSlide(sources[0]));
        mainHolder.innerHTML = '';
        mainHolder.appendChild(track);

        // state
        const count = sources.length, mod = (n, m) => ((n % m) + m) % m;
        let startActive = Math.max(0, items.findIndex(li => li.classList.contains('active')));
        if (startActive < 0) startActive = 0;

        let index = startActive + 1, slideW = 0;
        let animating = false;
        let queuedIndex = null;
        let queuedDir = null; // 'next' | 'prev'

        const setNavDisabled = (on) => {
            btnPrev?.classList.toggle('is-disabled', on);
            btnNext?.classList.toggle('is-disabled', on);
        };

        function jumpTo(i) {
            index = i;
            const prev = track.style.transition;
            track.style.transition = 'none';
            track.style.transform = `translateX(${-(index * slideW)}px)`;
            track.getBoundingClientRect(); // reflow
            track.style.transition = prev || 'transform .3s ease';
        }

        function goTo(i) {
            index = i;
            track.style.transform = `translateX(${-(index * slideW)}px)`;
        }

        // === FIX: safe resize (avoid stuck anim state) ===
        function setSizes() {
            const prev = track.style.transition;
            track.style.transition = 'none';
            slideW = mainHolder.clientWidth;
            [...track.children].forEach(el => el.style.width = slideW + 'px');
            track.style.transform = `translateX(${-(index * slideW)}px)`;
            track.getBoundingClientRect();
            track.style.transition = prev || 'transform .3s ease';

            if (animating) {
                animating = false;
                queuedIndex = null;
                queuedDir = null;
                setNavDisabled(false);
            }
            sync();
        }

        // guarded navigation (queue when animating)
        function safeGoTo(i) {
            if (animating) {
                queuedIndex = i;
                queuedDir = null;
                return;
            }
            animating = true;
            setNavDisabled(true);
            goTo(i);
        }

        function safeNext() {
            if (animating) {
                queuedIndex = null;
                queuedDir = 'next';
                return;
            }
            animating = true;
            setNavDisabled(true);
            goTo(index + 1);
        }

        function safePrev() {
            if (animating) {
                queuedIndex = null;
                queuedDir = 'prev';
                return;
            }
            animating = true;
            setNavDisabled(true);
            goTo(index - 1);
        }

        // thumbs active + autoscroll
        function setActive(iReal) {
            thumbsUl?.querySelector('.thumbs__item.active')?.classList.remove('active');
            items[iReal]?.classList.add('active');
        }

        function scrollThumbTo(i) {
            if (!thumbsWrap || !items[i]) return;
            const c = thumbsWrap, li = items[i];
            const liRect = li.getBoundingClientRect(), cRect = c.getBoundingClientRect();
            const leftInContent = liRect.left - cRect.left + c.scrollLeft;
            const target = Math.min(Math.max(0, leftInContent + liRect.width / 2 - c.clientWidth / 2), c.scrollWidth - c.clientWidth);
            c.scrollTo({left: target, behavior: 'smooth'});
        }

        function sync() {
            const real = mod(index - 1, count);
            setActive(real);
            scrollThumbTo(real);
        }

        setSizes();
        let rz;
        window.addEventListener('resize', () => {
            cancelAnimationFrame(rz);
            rz = requestAnimationFrame(setSizes);
        });

        // loop + queue drain
        track.addEventListener('transitionend', (ev) => {
            if (ev.propertyName !== 'transform') return;

            if (index === 0) jumpTo(count);
            else if (index === count + 1) jumpTo(1);

            sync();

            animating = false;
            setNavDisabled(false);

            if (queuedIndex != null) {
                const qi = queuedIndex;
                queuedIndex = null;
                safeGoTo(qi);
            } else if (queuedDir) {
                const dir = queuedDir;
                queuedDir = null;
                dir === 'next' ? safeNext() : safePrev();
            }
        });

        // arrows
        [btnPrev, btnNext].forEach(btn => btn?.addEventListener('pointerdown', e => e.stopPropagation(), {passive: true}));
        btnPrev?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            safePrev();
        });
        btnNext?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            safeNext();
        });

        // thumbs tap/drag on wrapper
        function handleThumbTap(target) {
            const li = target.closest('.thumbs__item');
            if (!li || !thumbsUl?.contains(li)) return;
            const i = items.indexOf(li);
            if (i === -1) return;
            safeGoTo(i + 1);
            setActive(i);
            scrollThumbTo(i);
        }

        if (thumbsWrap) {
            (function thumbsDragAndTap(el) {
                let down = false, dragging = false, startX = 0, startScroll = 0;
                const ACTIVATE = 8;

                el.addEventListener('pointerdown', (e) => {
                    if (e.button !== 0) return;
                    down = true;
                    dragging = false;
                    startX = e.clientX;
                    startScroll = el.scrollLeft;
                    el.setPointerCapture?.(e.pointerId);
                    el.classList.add('is-dragging');
                }, {passive: true});

                el.addEventListener('pointermove', (e) => {
                    if (!down) return;
                    const dx = e.clientX - startX;
                    if (!dragging && Math.abs(dx) > ACTIVATE) {
                        dragging = true;
                    }
                    if (dragging) {
                        el.scrollLeft = startScroll - dx;
                        e.preventDefault();
                    }
                }, {passive: false});

                function endThumb(e) {
                    if (!down) return;
                    el.releasePointerCapture?.(e.pointerId);
                    if (!dragging) {
                        handleThumbTap(e.target);
                    } else {
                        const blockOnce = (ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            el.removeEventListener('click', blockOnce, true);
                        };
                        el.addEventListener('click', blockOnce, true);
                    }
                    down = false;
                    dragging = false;
                    el.classList.remove('is-dragging');
                }

                el.addEventListener('pointerup', endThumb);
                el.addEventListener('pointercancel', endThumb);
                el.addEventListener('pointerleave', endThumb);
                el.addEventListener('dragstart', e => e.preventDefault());
            })(thumbsWrap);
        }

        // main drag/swipe
        let sx = 0, sy = 0, dx = 0, draggingMain = false;
        const TH = 40;

        mainHolder.addEventListener('pointerdown', e => {
            if (e.button !== 0 || animating) return;
            draggingMain = true;
            sx = e.clientX;
            sy = e.clientY;
            dx = 0;
            track.classList.add('is-dragging');
            track.style.transition = 'none';
            mainHolder.setPointerCapture?.(e.pointerId);
        }, {passive: true});

        mainHolder.addEventListener('pointermove', e => {
            if (!draggingMain) return;
            const mx = e.clientX - sx, my = e.clientY - sy;
            if (Math.abs(mx) > Math.abs(my)) e.preventDefault();
            dx = mx;
            track.style.transform = `translateX(${-(index * slideW) + dx}px)`;
        }, {passive: false});

        function endMain(e) {
            if (!draggingMain) return;
            draggingMain = false;
            track.classList.remove('is-dragging');
            track.style.transition = 'transform .3s ease';
            if (Math.abs(dx) > TH) (dx < 0 ? safeNext() : safePrev()); else safeGoTo(index);
            dx = 0;
            mainHolder.releasePointerCapture?.(e.pointerId);
        }

        mainHolder.addEventListener('pointerup', endMain);
        mainHolder.addEventListener('pointercancel', endMain);
        mainHolder.addEventListener('pointerleave', endMain);

        // keyboard
        mainHolder.tabIndex = 0;
        mainHolder.addEventListener('keydown', e => {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                safePrev();
            }
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                safeNext();
            }
        });

        // =========================
        // LIGHTBOX
        // =========================
        const createEl = (html) => {
            const t = document.createElement('template');
            t.innerHTML = html.trim();
            return t.content.firstElementChild;
        };

        // robust scroll lock (restores exact position)
        let __lockY = 0;

        function lockScroll(on) {
            const body = document.body;
            if (on) {
                __lockY = window.scrollY || window.pageYOffset;
                body.style.position = 'fixed';
                body.style.top = `-${__lockY}px`;
                body.style.left = '0';
                body.style.right = '0';
                body.style.width = '100%';
            } else {
                body.style.position = '';
                body.style.top = '';
                body.style.left = '';
                body.style.right = '';
                body.style.width = '';
                window.scrollTo(0, __lockY);
            }
        }

        function openLightbox(fromRealIndex) {
            let cur = typeof fromRealIndex === 'number' ? fromRealIndex : mod(index - 1, count);

            const lb = createEl(`
      <div class="lb" role="dialog" aria-modal="true" aria-label="Podgląd zdjęcia">
        <button class="lb__btn lb__close" aria-label="Zamknij (Esc)"></button>
        <button class="lb__btn lb__prev" aria-label="Poprzednie (←)"></button>
        <button class="lb__btn lb__next" aria-label="Następne (→)"></button>
        <div class="lb__stage"><img class="lb__img" alt=""></div>
      </div>`);
            document.body.appendChild(lb);
            lockScroll(true);

            const img = lb.querySelector('.lb__img');
            const btnClose = lb.querySelector('.lb__close');
            const btnPrev = lb.querySelector('.lb__prev');
            const btnNext = lb.querySelector('.lb__next');
            const stage = lb.querySelector('.lb__stage');

            function render() {
                const {src, alt, large} = sources[cur];
                img.src = large || src; // powiększenie: oryginał, jeśli strona pokazuje mniejszą wersję
                img.alt = alt || '';
            }

            function cleanupDragStates() {
                // wyczyść możliwe „down/dragging” w obu obszarach (naprawa scrola/drag po zamknięciu)
                thumbsWrap?.dispatchEvent(new Event('pointercancel', {bubbles: false}));
                mainHolder.dispatchEvent(new Event('pointercancel', {bubbles: false}));
                thumbsWrap?.classList.remove('is-dragging');
                track.classList.remove('is-dragging');
            }

            function close() {
                cleanupDragStates();
                lb.classList.add('is-leaving');
                lb.addEventListener('animationend', () => {
                    lb.remove();
                    lockScroll(false);
                }, {once: true});
                document.removeEventListener('keydown', onKey);
            }

            function prev() {
                cur = mod(cur - 1, count);
                render();
            }

            function next() {
                cur = mod(cur + 1, count);
                render();
            }

            // controls
            btnClose.addEventListener('click', close);
            btnPrev.addEventListener('click', prev);
            btnNext.addEventListener('click', next);

            // BACKDROP CLICK: close when clicking the dark overlay
            lb.addEventListener('click', (e) => {
                if (e.target === lb) close();
            });

            // ESC + arrows: keyboard support
            function onKey(e) {
                if (!document.body.contains(lb)) return;
                if (e.key === 'Escape') close();
                if (e.key === 'ArrowLeft') prev();
                if (e.key === 'ArrowRight') next();
            }

            document.addEventListener('keydown', onKey);

            // swipe in lightbox
            let ldx = 0, ldown = false, lsx = 0, lsy = 0;
            const LTH = 30;
            stage.addEventListener('pointerdown', e => {
                if (e.button !== 0) return;
                ldown = true;
                lsx = e.clientX;
                lsy = e.clientY;
                stage.setPointerCapture?.(e.pointerId);
            }, {passive: true});
            stage.addEventListener('pointermove', e => {
                if (!ldown) return;
                const mx = e.clientX - lsx, my = e.clientY - lsy;
                if (Math.abs(mx) > Math.abs(my)) e.preventDefault();
                ldx = mx;
            }, {passive: false});

            function endSwipe(e) {
                if (!ldown) return;
                ldown = false;
                stage.releasePointerCapture?.(e.pointerId);
                if (Math.abs(ldx) > LTH) (ldx < 0 ? next() : prev());
                ldx = 0;
            }

            stage.addEventListener('pointerup', endSwipe);
            stage.addEventListener('pointercancel', endSwipe);
            stage.addEventListener('pointerleave', endSwipe);

            render();
            btnClose.focus();
        }

        btnZoom?.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox();
        });
        mainHolder.addEventListener('dblclick', () => openLightbox());
    });
});
